import { clientToolOfLegacyResource } from '@cc/schema';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * E57 (Q-pia-3 A; registry decision `old-addresses`) — the ten Tools lists are Caseload › All records: an old list address
 * (`/tools/abcModels`, `/tools/portalThoughts`, …) opens All records with its tool ticked; a `?clientId=` it carried (the
 * thought-test list's deep link) becomes the client filter. No broken URL.
 */
export const LegacyToolListRedirect: React.FC<{ resource: string }> = ({ resource }) => {
  const { search } = useLocation();
  const tool = clientToolOfLegacyResource(resource);
  const next = new URLSearchParams();
  if (tool) next.set('tools', tool.key);
  const clientId = new URLSearchParams(search).get('clientId');
  if (clientId) next.set('client', clientId);
  return <Navigate to={`/caseload/records${next.toString() ? `?${next.toString()}` : ''}`} replace />;
};
